import { useState } from 'react';

import { Button, ButtonSize, ButtonType, IconSuccess } from '../../../core';
import { CTAContainer } from '../Links/Links.styled';

import {
  PlaygroundContainer,
  PlaygroundSelectors,
  SelectionFieldContainer,
} from './Buttons.styled';
import { buttonContents, buttonSizes, buttonStates, buttonTypes } from './data';

const Playground = () => {
  const [variant, setVariant] = useState<ButtonType>('primary');
  const [size, setSize] = useState<ButtonSize>('M');
  const [iconOnly, setIconOnly] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const shared = { variant, size, disabled, 'data-testid': 'playground-button' };

  return (
    <PlaygroundContainer>
      <PlaygroundSelectors>
        <SelectionFieldContainer
          data={buttonTypes}
          title="Variant selector"
          defaultValue={variant}
          onSelect={(value) => setVariant(value as ButtonType)}
        />
        <SelectionFieldContainer
          data={buttonSizes}
          title="Size selector"
          defaultValue={size}
          onSelect={(value) => setSize(value as ButtonSize)}
        />
        <SelectionFieldContainer
          data={buttonContents}
          title="Content selector"
          defaultValue="label"
          onSelect={(value) => setIconOnly(value === 'icon-only')}
        />
        <SelectionFieldContainer
          data={buttonStates}
          title="State selector"
          defaultValue="default"
          onSelect={(value) => setDisabled(value === 'disabled')}
        />
      </PlaygroundSelectors>
      <CTAContainer>
        {iconOnly ? (
          <Button {...shared} iconOnly icon={<IconSuccess />} aria-label="Button" />
        ) : (
          <Button {...shared} iconAfter={<IconSuccess />}>
            Button
          </Button>
        )}
      </CTAContainer>
    </PlaygroundContainer>
  );
};

export default Playground;
